module.exports = __webpack_public_path__ + "static/media/16UNODC10.ab0f488b.jpg";